<form class="flex-col flex" #form="ngForm">
    <mat-card class="cb-margin flex-col flex">
        <mat-card-header>
            <div class="start-start flex-row">
                <div class="cb-margin-right-2x flex-row" style="margin-top: 5px">
                    <mat-icon
                        [ngClass]="getStatusIconClass()"
                        class="help-cursor"
                        [matTooltip]="getStatusIconTitle()"
                        >{{ getStatusIconIcon() }}
                    </mat-icon>
                </div>
                <span class="mat-headline-6">{{ mappedItem.name }}</span>
            </div>
        </mat-card-header>
        <mat-card-content class="flex">
            <div class="flex-row flex">
                <div class="flex-col flex">
                    <cb-display-value-new
                        label="Assigned to"
                        [value]="mappedItem.assignedToUserName"
                    >
                    </cb-display-value-new>
                    <cb-display-value-new label="Reviewer" [value]="mappedItem.reviewerName">
                    </cb-display-value-new>
                    <cb-display-value-new
                        class="flex"
                        label="Status"
                        [value]="mappedItem.statusId | cbEnumToLabel: PRICING_REVISION_STATUS_ENUM"
                    >
                    </cb-display-value-new>
                    @if (!mappedItem.assignedToUserId) {
                        <cb-user-date-time-new
                            label="Created"
                            [floatingLabel]="true"
                            [userFullName]="mappedItem.createdByName"
                            [date]="mappedItem.createdDate"
                        >
                        </cb-user-date-time-new>
                    }
                    @if (mappedItem.isAwaitingReview) {
                        <cb-display-value-new
                            class="flex"
                            label="Waiting for Review by"
                            [value]="mappedItem.reviewerName"
                        >
                        </cb-display-value-new>
                    }
                    <cb-user-date-time-new
                        label="Due"
                        [floatingLabel]="true"
                        [date]="mappedItem.dueBy"
                    >
                    </cb-user-date-time-new>
                    @if (mappedItem.isAccepted) {
                        <cb-user-date-time-new
                            label="Accepted"
                            [floatingLabel]="true"
                            [date]="mappedItem.statusChangedDate"
                        >
                        </cb-user-date-time-new>
                    }
                    @if (mappedItem.isDeclined) {
                        <cb-user-date-time-new
                            label="Declined"
                            [floatingLabel]="true"
                            [date]="mappedItem.statusChangedDate"
                        >
                        </cb-user-date-time-new>
                    }

                    <cb-datepicker
                        label="Expiry Date"
                        name="pricingExpiryDate"
                        ngDefaultControl
                        [(ngModel)]="mappedItem.pricingExpiryDate"
                        pickerType="calendar"
                    >
                    </cb-datepicker>
                    @if (mappedItem.isOnHold) {
                        <div class="start-start flex-row">
                            <div class="flex-col">
                                <mat-icon class="mat-warn cb-margin">warning</mat-icon>
                            </div>
                            <div class="flex-col flex">
                                <cb-user-date-time-new
                                    label="On Hold since"
                                    [date]="mappedItem.statusChangedDate"
                                >
                                </cb-user-date-time-new>
                            </div>
                        </div>
                    }
                    @if (mappedItem.isAwaitingReview) {
                        <div class="start-start flex-row">
                            <div class="flex-col">
                                <mat-icon class="mat-accent">person</mat-icon>
                            </div>
                            <div class="flex-col flex">
                                <cb-display-value-new
                                    class="flex"
                                    label="Review Required by"
                                    [value]="mappedItem.reviewerName"
                                >
                                </cb-display-value-new>
                            </div>
                        </div>
                    }
                    @if (mappedItem.hasBeenReviewed) {
                        <div class="start-start flex-row">
                            <div class="flex-col">
                                <mat-icon class="mat-accent">person</mat-icon>
                            </div>
                            <div class="flex-col flex">
                                <cb-display-value-new
                                    class="flex"
                                    label="Review Required by"
                                    [value]="mappedItem.reviewerName"
                                >
                                </cb-display-value-new>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </mat-card-content>
        <mat-divider class="card-divider"></mat-divider>
        <mat-card-actions class="end-center flex-row">
            <span class="flex"></span>
            @if (canViewPricingRevision) {
                <cb-button [isStroked]="true" color="accent" (clicked)="viewPricingRevision()">
                    View
                </cb-button>
            }
        </mat-card-actions>
    </mat-card>
</form>
